import React, { useCallback } from 'react';
import { formatTranslation } from 'intl';
import { useIntl } from 'react-intl';
import { useGalleryContext } from '..';
import { identitySelector } from '../selectors';
import { InfoIcon } from '../icons';
import { getNoPermissionTitle } from './model';
import { ActionButton } from './actionButton';
import { IssueTranslationKeys } from 'intl/keys';

interface EditButtonProps {
  isMobile: boolean;
  onMenuClose?: () => void;
}

export const EditButton: React.FC<EditButtonProps> = ({
  isMobile,
  onMenuClose,
}) => {
  const intl = useIntl();
  const [file] =
    useGalleryContext().useMainDisplayedFile(identitySelector);
  const { preview, openEditComponent } = useGalleryContext();
  const EDIT_DESCRIPTION = formatTranslation(intl, IssueTranslationKeys.previewGalleryDescriptionEditLabel,);
  let editTooltipTitle = EDIT_DESCRIPTION;
  if (preview || !file) {
    editTooltipTitle = getNoPermissionTitle(intl);
  }

  const handleDescriptionEdit = useCallback((): void => {
    if (preview || !file) {
      return;
    }

    openEditComponent();
    if (onMenuClose) {
      onMenuClose();
    }
  }, [preview, file, openEditComponent, onMenuClose]);

  return (
    <ActionButton
      isMobile={isMobile}
      onClick={handleDescriptionEdit}
      disabled={preview}
      tooltipTitle={editTooltipTitle}
      label={EDIT_DESCRIPTION}
      icon={<InfoIcon />}
    />
  );
};
